import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const getYogaVideoByAccountId = async (accountId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/yogavideos/${accountId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching yoga videos:", error);
    throw error;
  }
};

